var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.665,
    viewBox: "0 0 20 17.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(-2 -3.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_112",
    "data-name": "Caminho 112",
    d: "M109.5,20l9-15.5m-9,0,9,15.5M105,12.5h18",
    transform: "translate(-102)",
    fill: "none",
    stroke: "#eeecef",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_55",
    "data-name": "Elipse 55",
    cx: 5.902,
    cy: 5.902,
    r: 5.902,
    transform: "translate(6.075 6.579)",
    fill: "#aacfff",
    stroke: "#63a4fe",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_113",
    "data-name": "Caminho 113",
    d: "M119.879,12.481c0,.1,0,.2-.007.3h-1.965a10.2,10.2,0,0,1-.33,2.324,8.625,8.625,0,0,1,1.319.643,5.873,5.873,0,0,1-.353.477,7.865,7.865,0,0,0-1.136-.552,8.418,8.418,0,0,1-1.131,2.25,5.893,5.893,0,0,1-1.033.329,6.571,6.571,0,0,0,.468-.556,7.789,7.789,0,0,0,1.14-2.22,9.456,9.456,0,0,0-2.579-.428v3.332c-.1,0-.2.008-.3.008s-.2,0-.295-.008V15.043a9.456,9.456,0,0,0-2.579.428,7.789,7.789,0,0,0,1.14,2.22,6.755,6.755,0,0,0,.467.556,5.909,5.909,0,0,1-1.032-.329,8.418,8.418,0,0,1-1.131-2.25,7.865,7.865,0,0,0-1.136.552,5.873,5.873,0,0,1-.353-.477,8.624,8.624,0,0,1,1.319-.643,10.2,10.2,0,0,1-.33-2.324h-1.965c0-.1-.007-.2-.007-.3s0-.2.007-.3h1.965a10.2,10.2,0,0,1,.33-2.325,8.529,8.529,0,0,1-1.319-.642,5.7,5.7,0,0,1,.353-.477,7.971,7.971,0,0,0,1.136.552,8.418,8.418,0,0,1,1.131-2.25,5.826,5.826,0,0,1,1.032-.329,6.592,6.592,0,0,0-.467.556,7.789,7.789,0,0,0-1.14,2.22,9.533,9.533,0,0,0,2.579.428V6.586c.1-.005.2-.007.295-.007s.2,0,.3.007V9.919a9.533,9.533,0,0,0,2.579-.428,7.789,7.789,0,0,0-1.14-2.22,6.417,6.417,0,0,0-.468-.556,5.81,5.81,0,0,1,1.033.329,8.418,8.418,0,0,1,1.131,2.25,7.971,7.971,0,0,0,1.136-.552,5.7,5.7,0,0,1,.353.477,8.53,8.53,0,0,1-1.319.642,10.2,10.2,0,0,1,.33,2.325h1.965C119.876,12.283,119.879,12.382,119.879,12.481Zm-2.562.3h-3.045v1.676a10.11,10.11,0,0,1,2.746.453A9.633,9.633,0,0,0,117.317,12.776Zm-3.635,1.676V12.776h-3.045a9.633,9.633,0,0,0,.3,2.129A10.116,10.116,0,0,1,113.682,14.452Zm3.635-2.266a9.633,9.633,0,0,0-.3-2.129,10.071,10.071,0,0,1-2.746.452v1.677Zm-3.635-1.677a10.078,10.078,0,0,1-2.746-.452,9.633,9.633,0,0,0-.3,2.129h3.045Z",
    transform: "translate(-102)",
    fill: "#63a4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_114",
    "data-name": "Caminho 114",
    d: "M109.555,4.564h8.96l4.48,7.76-4.48,7.76h-8.96l-4.481-7.76Z",
    transform: "translate(-102)",
    fill: "none",
    stroke: "#ffe07d",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_56",
    "data-name": "Elipse 56",
    cx: 1.287,
    cy: 1.287,
    r: 1.287,
    transform: "translate(15.069 3.471)",
    fill: "#b3e59e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_57",
    "data-name": "Elipse 57",
    cx: 1.287,
    cy: 1.287,
    r: 1.287,
    transform: "translate(19.426 11.017)",
    fill: "#b3e59e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_58",
    "data-name": "Elipse 58",
    cx: 1.287,
    cy: 1.287,
    r: 1.287,
    transform: "translate(15.069 18.562)",
    fill: "#b3e59e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_59",
    "data-name": "Elipse 59",
    cx: 1.287,
    cy: 1.287,
    r: 1.287,
    transform: "translate(6.356 18.562)",
    fill: "#b3e59e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_60",
    "data-name": "Elipse 60",
    cx: 1.287,
    cy: 1.287,
    r: 1.287,
    transform: "translate(2 11.017)",
    fill: "#b3e59e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_61",
    "data-name": "Elipse 61",
    cx: 1.287,
    cy: 1.287,
    r: 1.287,
    transform: "translate(6.356 3.471)",
    fill: "#b3e59e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipe);
export default __webpack_public_path__ + "static/media/equipe.66d3515662ec9268ffc90e2d5e4b235a.svg";
export { ForwardRef as ReactComponent };